import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const avatarRecipeFn = /* @__PURE__ */ createRecipe('avatar', {}, [])

const avatarRecipeVariantMap = {}

const avatarRecipeVariantKeys = Object.keys(avatarRecipeVariantMap)

export const avatarRecipe = /* @__PURE__ */ Object.assign(memo(avatarRecipeFn.recipeFn), {
  __recipe__: true,
  __name__: 'avatarRecipe',
  __getCompoundVariantCss__: avatarRecipeFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: avatarRecipeVariantKeys,
  variantMap: avatarRecipeVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, avatarRecipeVariantKeys)
  },
  getVariantProps: avatarRecipeFn.getVariantProps,
})